import qs from 'qs';

const useQueryParams = (location, readonly = false) => {
  const { pathname } = location;

  const pageInfo = window.sessionStorage.getItem(pathname);
  const urlParams = qs.parse(location.search, { ignoreQueryPrefix: true });

  if (urlParams.page) {
    urlParams.page = parseInt(urlParams.page, 10) > 0 ? urlParams.page : 1;
  }

  if (urlParams.limit) {
    urlParams.limit = parseInt(urlParams.limit, 10) > 0 ? urlParams.limit : 15;
  }

  const result = {
    ...{ page: 1, limit: 15, q: '' },
    ...JSON.parse(pageInfo),
    ...urlParams,
  };
  window.sessionStorage.setItem(pathname, JSON.stringify(result));

  const queryString = new URLSearchParams(result).toString();
  const newPath = `${pathname}?${queryString}`;
  if (!readonly && (result.page !== '1' || result.limit !== '15' || result.q !== '')) {
    window.history.replaceState(null, null, newPath);
  }

  return result;
};
export default useQueryParams;
